// Mobile menu with sliding submenu animations for 2-level navigation
class MobileMenuSlider {
  constructor(container) {
    this.container = container;
    this.openingClass = 'menu-opening';
    this.animationDuration = 250;
    this.closeDuration = 400;
    this.openingDetails = new Set(); // Prevent race conditions during rapid clicks
    
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.container.addEventListener('toggle', (e) => {
      const details = e.target;
      
      if (!details.classList.contains('mobile-menu__details')) {
        return;
      }

      if (details.open) {
        this.handleOpenSubmenu(details);
      }
    }, true);

    this.container.addEventListener('click', (e) => {
      const backButton = e.target.closest('.mobile-menu__back-button');
      
      if (backButton) {
        e.preventDefault();
        this.handleCloseSubmenu(backButton);
      }
    });

    this.container.addEventListener('click', (e) => {
      const closeButton = e.target.closest('.mobile-menu__submenu-close');
      
      if (closeButton) {
        e.preventDefault();
        this.handleCloseDrawer();
      }
    });
  }

  handleOpenSubmenu(details) {
    if (this.openingDetails.has(details)) {
      return;
    }

    this.openingDetails.add(details);

    const submenuWrapper = details.querySelector('.mobile-menu__submenu-wrapper');
    
    if (submenuWrapper) {
      const submenu = submenuWrapper.querySelector('.mobile-menu__submenu');
      
      if (submenu) {
        submenu.scrollTop = 0;
      }
    }

    // Double RAF ensures 'open' attribute is applied before animation class
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (details.open) {
          details.classList.add(this.openingClass);
          
          setTimeout(() => {
            this.openingDetails.delete(details);
          }, this.animationDuration);
        } else {
          this.openingDetails.delete(details);
        }
      });
    });
  }

  handleCloseSubmenu(backButton) {
    const details = backButton.closest('.mobile-menu__details');
    
    if (!details || !details.open) {
      return;
    }

    details.classList.remove(this.openingClass);

    // Wait for slide-out animation before removing open attribute
    setTimeout(() => {
      if (details.classList.contains('mobile-menu__details')) {
        details.open = false;
      }
    }, this.closeDuration);
  }

  openSubmenu(details) {
    if (!details || details.open) {
      return;
    }

    details.open = true;
  }

  closeSubmenu(details) {
    if (!details || !details.open) {
      return;
    }

    const backButton = details.querySelector('.mobile-menu__back-button');
    
    if (backButton) {
      this.handleCloseSubmenu(backButton);
    }
  }

  handleCloseDrawer() {
    const drawer = this.container.closest('.wt-drawer');
    
    if (drawer) {
      const mainCloseButton = drawer.querySelector('.wt-drawer__close');
      
      if (mainCloseButton) {
        mainCloseButton.click();
      }
    }
  }

  destroy() {
    this.openingDetails.clear();
  }
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileMenus);
  } else {
    initializeMobileMenus();
  }
}

function initializeMobileMenus() {
  const containers = document.querySelectorAll('.mobile-menu-container');
  
  containers.forEach((container) => {
    if (!container.mobileMenuSlider) {
      container.mobileMenuSlider = new MobileMenuSlider(container);
    }
  });
}
